
import React from "react";
import { CiWarning } from "react-icons/ci";
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";

/**
 * AiStatus
 * Props:
 * - label?: string
 * - size?: number
 * - showText?: boolean
 * - showTickIcon?: boolean
 */
export default function AiStatus({
  label = "Caution",
  size = 25,
  showText = false,
  showTickIcon = false,
}) {
  return (
    <div className="flex items-center gap-3">
      {/* Inline CSS for the blink animation */}
      <style>{`
        @keyframes blink {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.2; }
        }
        .blink {
          animation: blink 1s linear infinite;
        }
        @media (prefers-reduced-motion: reduce) {
          .blink { animation: none; }
        }
      `}</style>

      {showTickIcon ? (
        <IoCheckmarkDoneCircleOutline
          aria-label={label}
          role="img"
          className="blink text-green-600"
          size={size}
          color="green"
        />
      ) : (
        <CiWarning
          aria-label={label}
          role="img"
          className="blink text-red-600"
          size={size}
          color="red"
        />
      )}

      {showText && (
        <span
          className={`select-none font-medium tracking-wide ${
            showTickIcon ? "text-green-700" : "text-red-700"
          }`}
        >
          {label}
        </span>
      )}
    </div>
  );
}
